import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { modosOperacao, funcoesBotaoImprimir } from "../Layout/constants";

import { FaTicket, FaCreditCard } from "react-icons/fa6";
import { TbMoneybag } from "react-icons/tb";
import { MdAddCard } from "react-icons/md";
import { FaTrash } from "react-icons/fa";
import axios from "axios";
import DashboardCardapio from "./dash";

import { codigoEvento, convertAPIColor } from "../Utils/utils";

export default function ModalCardapios({
  cardapio,
  type,
  produtos,
  grupos,
  onClose,
  onNew,
  onEdit,
  onDelete,
  onRefresh,
}) {
  useEffect(() => {
    setModalData(cardapio);
    setModalType(type);
    setGruposList(grupos);
    setProdutosList(produtos);

    if (cardapio && Object.keys(cardapio).length > 0) {
      ordenarGrupos(cardapio.CODIGO);

      setCodigo(cardapio.CODIGO);
      setDescricao(cardapio.DESCRICAO ?? "");
      setNomeEvento(cardapio.NOMEEVENTO ?? "");
      setinfoAdic(cardapio.INFO ?? "");
      setmodoOp(
        modosOperacao.find((modo) => modo?.value === cardapio.MODOP)?.value
      );
      setBuscamodoOp(
        modosOperacao.find((modo) => modo?.value === cardapio.MODOP)?.label
      );
      setfuncBotaoImpr(
        funcoesBotaoImprimir.find(
          (funcao) => funcao?.value === String(cardapio.FUNCBOTAOIMPR)
        )?.value
      );
      setBuscaFuncaoBotaoImprimir(
        funcoesBotaoImprimir.find(
          (funcao) => funcao?.value === String(cardapio.FUNCBOTAOIMPR)
        )?.label
      );
      setsenha(cardapio.SENHA ?? "");
      setChaveCartao(cardapio.CHAVECARTAO ?? "");
      setValorCartao(cardapio.VALORCARTAO ?? 0);
      setsaldoRes(cardapio.SALDORES ?? 0);
      setValorMinimo(cardapio.VALORMINIMO ?? 0);
      setvalorNaFicha(cardapio.VALORNAFICHA === "S" ? true : false);
      setsenhaCanc(cardapio.SENHACANC === "S" ? true : false);
      setsenhaFecha(cardapio.SENHAFECHA === "S" ? true : false);
      setsenhaRetRef(cardapio.SENHARETREF === "S" ? true : false);
      setsenhaCadProd(cardapio.SENHACADPROD === "S" ? true : false);
      setsenhaCancFichas(cardapio.SENHACANCFICHAS === "S" ? true : false);
      setCargaAutomatica(cardapio.CARGAAUTOMATICA === "S" ? true : false);
      setSenhaRelatorio(cardapio.SENHARELATORIO === "S" ? true : false);
      setcpfSolicitacao(cardapio.cpfSolicitacao === "S" ? true : false);
      setcpfVerificacao(cardapio.cpfVerificacao === "S" ? true : false);
    }
  }, []);

  const navigate = useNavigate();

  const [modalType, setModalType] = useState("");
  const [modalData, setModalData] = useState({});

  const [codigo, setCodigo] = useState("");
  const [descricao, setDescricao] = useState("");
  const [nomeEvento, setNomeEvento] = useState("");
  const [infoAdic, setinfoAdic] = useState("");
  const [modoOp, setmodoOp] = useState("");
  const [funcBotaoImpr, setfuncBotaoImpr] = useState("");
  const [senha, setsenha] = useState("");
  const [chaveCartao, setChaveCartao] = useState("");
  const [valorCartao, setValorCartao] = useState("0");
  const [saldoRes, setsaldoRes] = useState("0");
  const [valorMinimo, setValorMinimo] = useState("0");
  const [valorNaFicha, setvalorNaFicha] = useState(false);
  const [senhaCanc, setsenhaCanc] = useState(false);
  const [senhaFecha, setsenhaFecha] = useState(false);
  const [senhaRetRef, setsenhaRetRef] = useState(false);
  const [senhaCadProd, setsenhaCadProd] = useState(false);
  const [senhaCancFichas, setsenhaCancFichas] = useState(false);
  const [cargaAutomatica, setCargaAutomatica] = useState(false);
  const [senhaRelatorio, setSenhaRelatorio] = useState(false);
  const [cpfSolicitacao, setcpfSolicitacao] = useState(false);
  const [cpfVerificacao, setcpfVerificacao] = useState(false);
  const [gruposList, setGruposList] = useState([]);
  const [produtosList, setProdutosList] = useState([]);
  const [valorProduto, setValorProduto] = useState("");

  const [buscaProduto, setBuscaProduto] = useState("");
  const [buscaGrupo, setBuscaGrupo] = useState("");
  const [buscamodoOp, setBuscamodoOp] = useState("");
  const [buscaFuncaoBotaoImprimir, setBuscaFuncaoBotaoImprimir] = useState("");
  const [abertoProduto, setAbertoProduto] = useState(false);
  const [abertoGrupo, setAbertoGrupo] = useState(false);
  const [abertomodoOp, setAbertomodoOp] = useState(false);
  const [abertoFuncaoBotaoImprimir, setAbertoFuncaoBotaoImprimir] =
    useState(false);
  const [itensCardapio, setItensCardapio] = useState([]);
  const [produto, setProduto] = useState({});
  const [grupo, setGrupo] = useState({});

  const iconSize = 20;

  const iconsOperacao = {
    NormalFichas: () => <FaTicket size={iconSize} />,
    RFIDCredito: () => <TbMoneybag size={iconSize} />,
    RFIDDebito: () => <FaCreditCard size={iconSize} />,
    RFIDDebitoCredito: () => <MdAddCard size={iconSize} />,
  };

  const produtosFiltrados = produtosList.filter(
    (produto) =>
      produto.DESCRICAO?.toLowerCase().includes(buscaProduto?.toLowerCase()) ||
      produto.CODIGO.toString().includes(buscaProduto?.toLowerCase())
  );

  const gruposFiltrados = gruposList.filter(
    (grupo) =>
      grupo.DESCRICAO?.toLowerCase().includes(buscaGrupo?.toLowerCase()) ||
      grupo.CODIGO.toString().includes(buscaGrupo?.toLowerCase())
  );

  const modosFiltrados = modosOperacao.filter((modo) =>
    modo.label?.toLowerCase().includes(buscamodoOp?.toLowerCase())
  );

  const funcoesFiltradas = funcoesBotaoImprimir.filter((funcao) =>
    funcao.label
      ?.toLowerCase()
      .includes(buscaFuncaoBotaoImprimir?.toLowerCase())
  );

  async function ordenarGrupos(codigoCardapio) {
    const retorno = await onRefresh(codigoCardapio);
    if (retorno.status) {
      cardapio = retorno.data[0];
    }
    console.log(cardapio);

    const gruposEditted = cardapio?.grupo?.map((item) => {
      item.produto.map((prd) => {
        const prodFind = produtos.find((prod) => prod.CODIGO === prd.CODIGO);

        if (prodFind) {
          prd.IMAGEM = prodFind.IMAGEM;
        }

        return prd;
      });
      return item;
    });

    setItensCardapio(gruposEditted);
  }

  function closeModal() {
    setModalType("");
    setModalData({});

    onClose();
  }

  function handleNewProduct() {
    navigate("/produtos?modaltype=create");
  }

  function handleSubmit(e) {
    e.preventDefault();

    const data = {
      codigoAluguel: codigoEvento(),
      codigo,
      descricao,
      nomeEvento,
      infoAdic,
      modoOp,
      funcBotaoImpr,
      senha,
      chaveCartao,
      valorCartao: parseFloat(valorCartao),
      saldoRes: parseFloat(saldoRes),
      valorMinimo: parseFloat(valorMinimo),
      valorNaFicha,
      senhaCanc,
      senhaFecha,
      senhaRetRef,
      senhaCadProd,
      senhaCancFichas,
      cargaAutomatica,
      senhaRelatorio,
      cpfSolicitacao,
      cpfVerificacao,
    };

    switch (modalType) {
      case "create":
        // todo: criar o cardápio após retorno da API (função deve ser feita na página principal)
        onNew(data);
        onClose();
        break;
      case "edit":
        // todo: editar o cardápio após retorno da API (função deve ser feita na página principal)
        onEdit(data);
        onClose();
        break;
      default:
        // todo: deletar o cardápio após retorno da API (função deve ser feita na página principal)
        onDelete(data);
        onClose();
        break;
    }
  }

  function handleAddItem(e) {
    e.preventDefault();
    let data = {
      codaluguel: codigoEvento(),
      codcardapio: String(codigo),
      itensCardapio: [
        {
          codGrupo: String(grupo.CODIGO),
          descGrupo: String(grupo.DESCRICAO),
          codProd: String(produto.CODIGO),
          descProd: String(produto.DESCRICAO),
          valor: String(valorProduto),
          cor: String(produto.COR),
        },
      ],
    };

    console.log("data", data);

    axios
      .post(`${process.env.REACT_APP_API_URL}/ItensCardapio`, data, {
        headers: {
          auth: process.env.REACT_APP_API_TOKEN,
          "Content-Type": "application/json",
        },
      })
      .then((retorno) => {
        const newItem = {
          DESCRICAO: grupo.DESCRICAO,
          CODIGO: grupo.CODIGO,
          IMAGEM: grupo.IMAGEM,
          COR: grupo.COR,
          produto: [],
        };

        newItem.produto.push({
          DESCRICAO: produto.DESCRICAO,
          CODIGO: produto.CODIGO,
          IMAGEM: produto.IMAGEM,
          COR: produto.COR,
          VALOR: parseFloat(valorProduto),
        });

        // todo: adicionar o produto no grupo após retorno da API
        setItensCardapio((prev) => [...prev, newItem]);
        ordenarGrupos(cardapio.CODIGO);
        setProduto({});
        setBuscaProduto("");
        setGrupo({});
        setBuscaGrupo("");
        setValorProduto("");
      });
  }

  function handleRemoveItem(codigoGrupo, codigoProduto) {
    const confirm = window.confirm(`Tem certeza que deseja excluir o item?`);
    if (!confirm) return;

    axios
      .delete(`${process.env.REACT_APP_API_URL}/ItensCardapio`, {
        headers: { auth: process.env.REACT_APP_API_TOKEN },
        params: {
          codaluguel: codigoEvento(),
          codigoCardapio: codigo,
          codProd: codigoProduto,
        },
      })
      .then((res) => {
        let updatedItensCardapio = itensCardapio.map((item) => {
          if (item.CODIGO === codigoGrupo) {
            return {
              ...item,
              produto: item.produto.filter(
                (prod) => prod.CODIGO !== codigoProduto
              ),
            };
          }
          return item;
        });

        updatedItensCardapio = updatedItensCardapio.filter(
          (item) => item?.produto?.length > 0
        );
        // todo: remover o produto do grupo após retorno da API
        setItensCardapio(updatedItensCardapio);
        ordenarGrupos(cardapio.CODIGO);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }

  return (
    <div className="fixed inset-0 z-10 flex items-center justify-center">
      <div
        onClick={() => {
          closeModal();
        }}
        className="absolute h-screen inset-0 bg-black/60 backdrop-blur-sm"
      ></div>
      <div className="relative z-20 bg-white rounded-lg w-[95%] lg:w-[95%] max-h-[80vh] overflow-hidden flex flex-col">
        <div className="overflow-y-auto p-4 flex-1">
          {modalType === "create" ? (
            <div className="flex flex-col box-border p-4 gap-2 w-full">
              <h1 className="font-Oswald text-center">Novo Cardápio</h1>

              <form
                onSubmit={(e) => handleSubmit(e)}
                autoComplete="off"
                className="flex flex-col flex-wrap gap-2 w-full"
              >
                <div className="grid col-span-2 grid-cols-1 md:grid-cols-3 gap-4 w-full">
                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <label htmlFor="descricao">Descrição</label>
                    <input
                      name="descricao"
                      type="text"
                      onChange={(e) => setDescricao(e.target.value)}
                      className="font-Roboto text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={descricao}
                      placeholder="Descrição"
                      required
                    />
                  </div>
                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <label htmlFor="nomeEvento">Nome do Evento</label>
                    <input
                      name="nomeEvento"
                      type="text"
                      onChange={(e) => setNomeEvento(e.target.value)}
                      className="font-Roboto text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={nomeEvento}
                      placeholder="Nome do Evento"
                    />
                  </div>
                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <label htmlFor="infoAdic">Informações Adicionais</label>
                    <input
                      name="infoAdic"
                      type="text"
                      onChange={(e) => setinfoAdic(e.target.value)}
                      className="font-Roboto text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={infoAdic}
                      placeholder="Informações Adicionais"
                    />
                  </div>
                </div>

                <div className="grid col-span-2 grid-cols-1 md:grid-cols-3 gap-4 w-full">
                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <label
                      className="font-Roboto text-base font-[500] w-fit"
                      htmlFor="modoOp"
                    >
                      Modo de Operação
                    </label>
                    <div className="font-Roboto font-[500] relative w-full">
                      <input
                        autoComplete="off"
                        type="text"
                        name="modoOp"
                        className="font-Roboto w-fill-available text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="Selecione uma opção"
                        value={modoOp}
                        onChange={(e) => {
                          setBuscamodoOp(e.target.value);
                          setAbertomodoOp(!abertomodoOp);
                        }}
                        onFocus={() => {
                          setBuscamodoOp("");
                          setAbertomodoOp(!abertomodoOp);
                        }}
                      />

                      {abertomodoOp && (
                        <ul className="font-Roboto flex flex-col  text-base font-[500] absolute z-10 w-full overflow-x-hidden bg-white border border-gray-300 rounded-md max-h-60 overflow-y-auto shadow-md">
                          {modosFiltrados.length > 0 ? (
                            modosFiltrados.map((option) => (
                              <li
                                style={{
                                  backgroundColor: option.color,
                                }}
                                key={option.value}
                                className="px-4 py-2 cursor-pointer hover:bg-blue-100"
                                onClick={() => {
                                  setmodoOp(option.value);
                                  setBuscamodoOp(option.label);
                                  setAbertomodoOp(false);
                                }}
                              >
                                <div className="flex box-border items-center gap-4">
                                  {iconsOperacao[option.icon]?.()}
                                  <span className="text-wrap break-words">
                                    {option.label}
                                  </span>
                                </div>
                              </li>
                            ))
                          ) : (
                            <li className="font-Roboto px-4 py-2 text-gray-500">
                              Nenhuma opção encontrada
                            </li>
                          )}
                        </ul>
                      )}
                    </div>
                  </div>

                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <label
                      className="font-Roboto text-base font-[500] w-fit"
                      htmlFor="funcaoBotaoImprimir"
                    >
                      Função do Botão Imprimir
                    </label>
                    <div className="font-Roboto font-[500] relative w-full">
                      <input
                        autoComplete="off"
                        type="text"
                        name="funcaoBotaoImprimir"
                        className="font-Roboto w-fill-available text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="Selecione uma opção"
                        value={buscaFuncaoBotaoImprimir}
                        onChange={(e) => {
                          setBuscaFuncaoBotaoImprimir(e.target.value);
                          // setAbertoFuncaoBotaoImprimir(
                          //   !abertoFuncaoBotaoImprimir
                          // );
                        }}
                        onFocus={() => {
                          setBuscaFuncaoBotaoImprimir("");
                          setAbertoFuncaoBotaoImprimir(
                            !abertoFuncaoBotaoImprimir
                          );
                        }}
                      />

                      {abertoFuncaoBotaoImprimir && (
                        <ul className="font-Roboto flex flex-col  text-base font-[500] absolute z-10 w-full overflow-x-hidden bg-white border border-gray-300 rounded-md max-h-60 overflow-y-auto shadow-md">
                          {funcoesFiltradas.length > 0 ? (
                            funcoesFiltradas.map((option) => (
                              <li
                                key={option.value}
                                className="px-4 py-2 cursor-pointer hover:bg-blue-100"
                                onClick={() => {
                                  setfuncBotaoImpr(option.value);
                                  setBuscaFuncaoBotaoImprimir(option.label);
                                  setAbertoFuncaoBotaoImprimir(false);
                                }}
                              >
                                <div className="flex box-border items-center gap-4">
                                  <span className="text-wrap break-words">
                                    {option.label}
                                  </span>
                                </div>
                              </li>
                            ))
                          ) : (
                            <li className="font-Roboto px-4 py-2 text-gray-500">
                              Nenhuma opção encontrada
                            </li>
                          )}
                        </ul>
                      )}
                    </div>
                  </div>
                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <label htmlFor="senhaOperacoes">Senha para Operações</label>
                    <input
                      name="senhaOperacoes"
                      type="text"
                      onChange={(e) => setsenha(e.target.value)}
                      className="font-Roboto text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={senha}
                      placeholder="Senha para Operações"
                    />
                  </div>
                </div>

                <div className="grid col-span-2 grid-cols-1 md:grid-cols-4 gap-4 w-full">
                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <label htmlFor="chaveCartao">Chave do Cartão</label>
                    <input
                      name="chaveCartao"
                      type="text"
                      onChange={(e) => setChaveCartao(e.target.value)}
                      className="font-Roboto text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={chaveCartao}
                      placeholder="Chave do Cartão"
                    />
                  </div>
                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <label htmlFor="valorCartao">Valor do Cartão</label>
                    <input
                      name="valorCartao"
                      type="number"
                      min="0"
                      step="0.01"
                      onChange={(e) => setValorCartao(e.target.value)}
                      className="font-Roboto text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={valorCartao}
                    />
                  </div>
                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <label htmlFor="saldoRes">Saldo Residual</label>
                    <input
                      name="saldoRes"
                      type="number"
                      min="0"
                      step="0.01"
                      onChange={(e) => setsaldoRes(e.target.value)}
                      className="font-Roboto text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={saldoRes}
                    />
                  </div>
                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <label htmlFor="valorMinimo">Valor Mínimo</label>
                    <input
                      name="valorMinimo"
                      type="number"
                      min="0"
                      step="0.01"
                      onChange={(e) => setValorMinimo(e.target.value)}
                      className="font-Roboto text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={valorMinimo}
                    />
                  </div>
                </div>

                <div className="grid col-span-2 grid-cols-1 md:grid-cols-4 gap-4 w-full">
                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <button
                      type="button"
                      onClick={() => setvalorNaFicha(!valorNaFicha)}
                      className={`cursor-pointer w-14 h-8 flex items-center p-1 rounded-full 
                              transition-colors duration-300 ease-in-out border-none
                              ${valorNaFicha ? "bg-blue-500" : "bg-gray-300"}`}
                    >
                      <span
                        className={`w-6 h-6 bg-white rounded-full shadow-md 
                              transition-transform duration-300 ease-in-out
                              ${
                                valorNaFicha ? "translate-x-6" : "translate-x-0"
                              }`}
                      ></span>
                    </button>
                    <span className="text-sm">Impr. Valor na Ficha</span>
                  </div>

                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <button
                      type="button"
                      onClick={() => setsenhaCanc(!senhaCanc)}
                      className={`cursor-pointer w-14 h-8 flex items-center p-1 rounded-full 
                              transition-colors duration-300 ease-in-out border-none
                              ${senhaCanc ? "bg-blue-500" : "bg-gray-300"}`}
                    >
                      <span
                        className={`w-6 h-6 bg-white rounded-full shadow-md 
                              transition-transform duration-300 ease-in-out
                              ${senhaCanc ? "translate-x-6" : "translate-x-0"}`}
                      ></span>
                    </button>
                    <span className="text-sm">Senha nos Cancelamentos</span>
                  </div>

                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <button
                      type="button"
                      onClick={() => setsenhaFecha(!senhaFecha)}
                      className={`cursor-pointer w-14 h-8 flex items-center p-1 rounded-full 
                              transition-colors duration-300 ease-in-out border-none
                              ${senhaFecha ? "bg-blue-500" : "bg-gray-300"}`}
                    >
                      <span
                        className={`w-6 h-6 bg-white rounded-full shadow-md 
                              transition-transform duration-300 ease-in-out
                              ${
                                senhaFecha ? "translate-x-6" : "translate-x-0"
                              }`}
                      ></span>
                    </button>
                    <span className="text-sm">Senha nos Fechamentos</span>
                  </div>

                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <button
                      type="button"
                      onClick={() => setsenhaRetRef(!senhaRetRef)}
                      className={`cursor-pointer w-14 h-8 flex items-center p-1 rounded-full 
                              transition-colors duration-300 ease-in-out border-none
                              ${senhaRetRef ? "bg-blue-500" : "bg-gray-300"}`}
                    >
                      <span
                        className={`w-6 h-6 bg-white rounded-full shadow-md 
                              transition-transform duration-300 ease-in-out
                              ${
                                senhaRetRef ? "translate-x-6" : "translate-x-0"
                              }`}
                      ></span>
                    </button>
                    <span className="text-sm">Senha na Retirada/Reforço</span>
                  </div>

                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <button
                      type="button"
                      onClick={() => setsenhaCadProd(!senhaCadProd)}
                      className={`cursor-pointer w-14 h-8 flex items-center p-1 rounded-full 
                              transition-colors duration-300 ease-in-out border-none
                              ${senhaCadProd ? "bg-blue-500" : "bg-gray-300"}`}
                    >
                      <span
                        className={`w-6 h-6 bg-white rounded-full shadow-md 
                              transition-transform duration-300 ease-in-out
                              ${
                                senhaCadProd ? "translate-x-6" : "translate-x-0"
                              }`}
                      ></span>
                    </button>
                    <span className="text-sm">
                      Senha nos Cadastros de Produtos
                    </span>
                  </div>

                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <button
                      type="button"
                      onClick={() => setsenhaCancFichas(!senhaCancFichas)}
                      className={`cursor-pointer w-14 h-8 flex items-center p-1 rounded-full 
                              transition-colors duration-300 ease-in-out border-none
                              ${
                                senhaCancFichas ? "bg-blue-500" : "bg-gray-300"
                              }`}
                    >
                      <span
                        className={`w-6 h-6 bg-white rounded-full shadow-md 
                              transition-transform duration-300 ease-in-out
                              ${
                                senhaCancFichas
                                  ? "translate-x-6"
                                  : "translate-x-0"
                              }`}
                      ></span>
                    </button>
                    <span className="text-sm">Senha ao Cancelar Fichas</span>
                  </div>

                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <button
                      type="button"
                      onClick={() => setCargaAutomatica(!cargaAutomatica)}
                      className={`cursor-pointer w-14 h-8 flex items-center p-1 rounded-full 
                              transition-colors duration-300 ease-in-out border-none
                              ${
                                cargaAutomatica ? "bg-blue-500" : "bg-gray-300"
                              }`}
                    >
                      <span
                        className={`w-6 h-6 bg-white rounded-full shadow-md 
                              transition-transform duration-300 ease-in-out
                              ${
                                cargaAutomatica
                                  ? "translate-x-6"
                                  : "translate-x-0"
                              }`}
                      ></span>
                    </button>
                    <span className="text-sm">Carga Automática</span>
                  </div>

                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <button
                      type="button"
                      onClick={() => setSenhaRelatorio(!senhaRelatorio)}
                      className={`cursor-pointer w-14 h-8 flex items-center p-1 rounded-full 
                              transition-colors duration-300 ease-in-out border-none
                              ${
                                senhaRelatorio ? "bg-blue-500" : "bg-gray-300"
                              }`}
                    >
                      <span
                        className={`w-6 h-6 bg-white rounded-full shadow-md 
                              transition-transform duration-300 ease-in-out
                              ${
                                senhaRelatorio
                                  ? "translate-x-6"
                                  : "translate-x-0"
                              }`}
                      ></span>
                    </button>
                    <span className="text-sm">Senha nos Relatórios</span>
                  </div>

                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <button
                      type="button"
                      onClick={() => setcpfSolicitacao(!cpfSolicitacao)}
                      className={`cursor-pointer w-14 h-8 flex items-center p-1 rounded-full 
                              transition-colors duration-300 ease-in-out border-none
                              ${
                                cpfSolicitacao ? "bg-blue-500" : "bg-gray-300"
                              }`}
                    >
                      <span
                        className={`w-6 h-6 bg-white rounded-full shadow-md 
                              transition-transform duration-300 ease-in-out
                              ${
                                cpfSolicitacao
                                  ? "translate-x-6"
                                  : "translate-x-0"
                              }`}
                      ></span>
                    </button>
                    <span className="text-sm">Solicitar CPF Novo Cartão</span>
                  </div>

                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <button
                      type="button"
                      onClick={() => setcpfVerificacao(!cpfVerificacao)}
                      className={`cursor-pointer w-14 h-8 flex items-center p-1 rounded-full 
                              transition-colors duration-300 ease-in-out border-none
                              ${
                                cpfVerificacao ? "bg-blue-500" : "bg-gray-300"
                              }`}
                    >
                      <span
                        className={`w-6 h-6 bg-white rounded-full shadow-md 
                              transition-transform duration-300 ease-in-out
                              ${
                                cpfVerificacao
                                  ? "translate-x-6"
                                  : "translate-x-0"
                              }`}
                      ></span>
                    </button>
                    <span className="text-sm">Verificar CPF Novo Cartão</span>
                  </div>
                </div>

                <div className="flex gap-2 justify-end w-full">
                  <button
                    type="button"
                    onClick={() => {
                      closeModal();
                    }}
                    className="flex gap-2 font-[500] items-center rounded-lg text-lg border-none p-2 bg-[#e74c3c]  text-white transition cursor-pointer hover:bg-[#c0392b] font-Roboto"
                  >
                    Cancelar
                  </button>
                  <button
                    type="submit"
                    className="flex gap-2 font-[500] items-center rounded-lg text-lg border-none p-2 bg-[#2185D0] text-white transition cursor-pointer hover:bg-[#1A6DA8] font-Roboto"
                  >
                    Salvar
                  </button>
                </div>
              </form>
            </div>
          ) : modalType === "edit" ? (
            <div className="flex flex-col box-border p-4 gap-2 w-full">
              <h1 className="font-Oswald text-center">Editar Cardápio</h1>

              <form
                onSubmit={(e) => handleSubmit(e)}
                autoComplete="off"
                className="flex flex-col flex-wrap gap-2 w-full"
              >
                <div className="grid col-span-2 grid-cols-1 md:grid-cols-4 gap-4 w-full">
                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <label htmlFor="codigo">Código</label>
                    <input
                      name="codigo"
                      type="text"
                      className="font-Roboto text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={codigo}
                      placeholder="Descrição"
                      disabled
                    />
                  </div>
                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <label htmlFor="descricao">Descrição</label>
                    <input
                      name="descricao"
                      type="text"
                      onChange={(e) => setDescricao(e.target.value)}
                      className="font-Roboto text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={descricao}
                      placeholder="Descrição"
                      required
                    />
                  </div>
                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <label htmlFor="nomeEvento">Nome do Evento</label>
                    <input
                      name="nomeEvento"
                      type="text"
                      onChange={(e) => setNomeEvento(e.target.value)}
                      className="font-Roboto text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={nomeEvento}
                      placeholder="Nome do Evento"
                    />
                  </div>
                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <label htmlFor="infoAdic">Informações Adicionais</label>
                    <input
                      name="infoAdic"
                      type="text"
                      onChange={(e) => setinfoAdic(e.target.value)}
                      className="font-Roboto text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={infoAdic}
                      placeholder="Informações Adicionais"
                    />
                  </div>
                </div>

                <div className="grid col-span-2 grid-cols-1 md:grid-cols-3 gap-4 w-full">
                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <label
                      className="font-Roboto text-base font-[500] w-full"
                      htmlFor="modoOp"
                    >
                      Modo de Operação
                    </label>
                    <div className="font-Roboto font-[500] relative w-full">
                      <input
                        autoComplete="off"
                        type="text"
                        name="modoOp"
                        className="font-Roboto w-fill-available text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="Selecione uma opção"
                        value={buscamodoOp}
                        onChange={(e) => {
                          setBuscamodoOp(e.target.value);
                          setAbertomodoOp(!abertomodoOp);
                        }}
                        onFocus={() => {
                          setBuscamodoOp("");
                          setAbertomodoOp(!abertomodoOp);
                        }}
                      />

                      {abertomodoOp && (
                        <ul className="font-Roboto flex flex-col  text-base font-[500] absolute z-10 w-full overflow-x-hidden bg-white border border-gray-300 rounded-md max-h-60 overflow-y-auto shadow-md">
                          {modosFiltrados.length > 0 ? (
                            modosFiltrados.map((option) => (
                              <li
                                style={{
                                  backgroundColor: option.color,
                                }}
                                key={option.value}
                                className="px-4 py-2 cursor-pointer hover:bg-blue-100"
                                onClick={() => {
                                  setmodoOp(option.value);
                                  setBuscamodoOp(option.label);
                                  setAbertomodoOp(false);
                                }}
                              >
                                <div className="flex box-border items-center gap-4">
                                  {iconsOperacao[option.icon]?.()}
                                  <span className="text-wrap break-words">
                                    {option.label}
                                  </span>
                                </div>
                              </li>
                            ))
                          ) : (
                            <li className="font-Roboto px-4 py-2 text-gray-500">
                              Nenhuma opção encontrada
                            </li>
                          )}
                        </ul>
                      )}
                    </div>
                  </div>

                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <label
                      className="font-Roboto text-base font-[500] w-full"
                      htmlFor="funcaoBotaoImprimir"
                    >
                      Função do Botão Imprimir
                    </label>
                    <div className="font-Roboto font-[500] relative w-full">
                      <input
                        autoComplete="off"
                        type="text"
                        name="funcaoBotaoImprimir"
                        className="font-Roboto w-fill-available text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="Selecione uma opção"
                        value={buscaFuncaoBotaoImprimir}
                        onChange={(e) => {
                          setBuscaFuncaoBotaoImprimir(e.target.value);
                          // setAbertoFuncaoBotaoImprimir(
                          //   !abertoFuncaoBotaoImprimir
                          // );
                        }}
                        onFocus={() => {
                          setBuscaFuncaoBotaoImprimir("");
                          setAbertoFuncaoBotaoImprimir(
                            !abertoFuncaoBotaoImprimir
                          );
                        }}
                      />

                      {abertoFuncaoBotaoImprimir && (
                        <ul className="font-Roboto flex flex-col  text-base font-[500] absolute z-10 w-full overflow-x-hidden bg-white border border-gray-300 rounded-md max-h-60 overflow-y-auto shadow-md">
                          {funcoesFiltradas.length > 0 ? (
                            funcoesFiltradas.map((option) => (
                              <li
                                key={option.value}
                                className="px-4 py-2 cursor-pointer hover:bg-blue-100"
                                onClick={() => {
                                  setfuncBotaoImpr(option.value);
                                  setBuscaFuncaoBotaoImprimir(option.label);
                                  setAbertoFuncaoBotaoImprimir(false);
                                }}
                              >
                                <div className="flex box-border items-center gap-4">
                                  <span className="text-wrap break-words">
                                    {option.label}
                                  </span>
                                </div>
                              </li>
                            ))
                          ) : (
                            <li className="font-Roboto px-4 py-2 text-gray-500">
                              Nenhuma opção encontrada
                            </li>
                          )}
                        </ul>
                      )}
                    </div>
                  </div>

                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <label htmlFor="senhaOperacoes">Senha para Operações</label>
                    <input
                      name="senhaOperacoes"
                      type="text"
                      onChange={(e) => setsenha(e.target.value)}
                      className="font-Roboto text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={senha}
                      placeholder="Senha para Operações"
                    />
                  </div>
                </div>

                <div className="grid col-span-2 grid-cols-1 md:grid-cols-4 gap-4 w-full">
                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <label htmlFor="chaveCartao">Chave do Cartão</label>
                    <input
                      name="chaveCartao"
                      type="text"
                      onChange={(e) => setChaveCartao(e.target.value)}
                      className="font-Roboto text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={chaveCartao}
                      placeholder="Chave do Cartão"
                    />
                  </div>
                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <label htmlFor="valorCartao">Valor do Cartão</label>
                    <input
                      name="valorCartao"
                      type="number"
                      min="0"
                      step="0.01"
                      onChange={(e) => setValorCartao(e.target.value)}
                      className="font-Roboto text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={valorCartao}
                    />
                  </div>
                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <label htmlFor="saldoRes">Saldo Residual</label>
                    <input
                      name="saldoRes"
                      type="number"
                      min="0"
                      step="0.01"
                      onChange={(e) => setsaldoRes(e.target.value)}
                      className="font-Roboto text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={saldoRes}
                    />
                  </div>
                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <label htmlFor="valorMinimo">Valor Mínimo</label>
                    <input
                      name="valorMinimo"
                      type="number"
                      min="0"
                      step="0.01"
                      onChange={(e) => setValorMinimo(e.target.value)}
                      className="font-Roboto text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={valorMinimo}
                    />
                  </div>
                </div>

                <div className="grid col-span-2 grid-cols-1 md:grid-cols-4 gap-4 w-full">
                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <button
                      type="button"
                      onClick={() => setvalorNaFicha(!valorNaFicha)}
                      className={`cursor-pointer w-14 h-8 flex items-center p-1 rounded-full 
                              transition-colors duration-300 ease-in-out border-none
                              ${valorNaFicha ? "bg-blue-500" : "bg-gray-300"}`}
                    >
                      <span
                        className={`w-6 h-6 bg-white rounded-full shadow-md 
                              transition-transform duration-300 ease-in-out
                              ${
                                valorNaFicha ? "translate-x-6" : "translate-x-0"
                              }`}
                      ></span>
                    </button>
                    <span className="text-sm">Impr. Valor na Ficha</span>
                  </div>

                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <button
                      type="button"
                      onClick={() => setsenhaCanc(!senhaCanc)}
                      className={`cursor-pointer w-14 h-8 flex items-center p-1 rounded-full 
                              transition-colors duration-300 ease-in-out border-none
                              ${senhaCanc ? "bg-blue-500" : "bg-gray-300"}`}
                    >
                      <span
                        className={`w-6 h-6 bg-white rounded-full shadow-md 
                              transition-transform duration-300 ease-in-out
                              ${senhaCanc ? "translate-x-6" : "translate-x-0"}`}
                      ></span>
                    </button>
                    <span className="text-sm">Senha nos Cancelamentos</span>
                  </div>

                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <button
                      type="button"
                      onClick={() => setsenhaFecha(!senhaFecha)}
                      className={`cursor-pointer w-14 h-8 flex items-center p-1 rounded-full 
                              transition-colors duration-300 ease-in-out border-none
                              ${senhaFecha ? "bg-blue-500" : "bg-gray-300"}`}
                    >
                      <span
                        className={`w-6 h-6 bg-white rounded-full shadow-md 
                              transition-transform duration-300 ease-in-out
                              ${
                                senhaFecha ? "translate-x-6" : "translate-x-0"
                              }`}
                      ></span>
                    </button>
                    <span className="text-sm">Senha nos Fechamentos</span>
                  </div>

                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <button
                      type="button"
                      onClick={() => setsenhaRetRef(!senhaRetRef)}
                      className={`cursor-pointer w-14 h-8 flex items-center p-1 rounded-full 
                              transition-colors duration-300 ease-in-out border-none
                              ${senhaRetRef ? "bg-blue-500" : "bg-gray-300"}`}
                    >
                      <span
                        className={`w-6 h-6 bg-white rounded-full shadow-md 
                              transition-transform duration-300 ease-in-out
                              ${
                                senhaRetRef ? "translate-x-6" : "translate-x-0"
                              }`}
                      ></span>
                    </button>
                    <span className="text-sm">Senha na Retirada/Reforço</span>
                  </div>

                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <button
                      type="button"
                      onClick={() => setsenhaCadProd(!senhaCadProd)}
                      className={`cursor-pointer w-14 h-8 flex items-center p-1 rounded-full 
                              transition-colors duration-300 ease-in-out border-none
                              ${senhaCadProd ? "bg-blue-500" : "bg-gray-300"}`}
                    >
                      <span
                        className={`w-6 h-6 bg-white rounded-full shadow-md 
                              transition-transform duration-300 ease-in-out
                              ${
                                senhaCadProd ? "translate-x-6" : "translate-x-0"
                              }`}
                      ></span>
                    </button>
                    <span className="text-sm">
                      Senha nos Cadastros de Produtos
                    </span>
                  </div>

                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <button
                      type="button"
                      onClick={() => setsenhaCancFichas(!senhaCancFichas)}
                      className={`cursor-pointer w-14 h-8 flex items-center p-1 rounded-full 
                              transition-colors duration-300 ease-in-out border-none
                              ${
                                senhaCancFichas ? "bg-blue-500" : "bg-gray-300"
                              }`}
                    >
                      <span
                        className={`w-6 h-6 bg-white rounded-full shadow-md 
                              transition-transform duration-300 ease-in-out
                              ${
                                senhaCancFichas
                                  ? "translate-x-6"
                                  : "translate-x-0"
                              }`}
                      ></span>
                    </button>
                    <span className="text-sm">Senha ao Cancelar Fichas</span>
                  </div>

                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <button
                      type="button"
                      onClick={() => setCargaAutomatica(!cargaAutomatica)}
                      className={`cursor-pointer w-14 h-8 flex items-center p-1 rounded-full 
                              transition-colors duration-300 ease-in-out border-none
                              ${
                                cargaAutomatica ? "bg-blue-500" : "bg-gray-300"
                              }`}
                    >
                      <span
                        className={`w-6 h-6 bg-white rounded-full shadow-md 
                              transition-transform duration-300 ease-in-out
                              ${
                                cargaAutomatica
                                  ? "translate-x-6"
                                  : "translate-x-0"
                              }`}
                      ></span>
                    </button>
                    <span className="text-sm">Carga Automática</span>
                  </div>

                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <button
                      type="button"
                      onClick={() => setSenhaRelatorio(!senhaRelatorio)}
                      className={`cursor-pointer w-14 h-8 flex items-center p-1 rounded-full 
                              transition-colors duration-300 ease-in-out border-none
                              ${
                                senhaRelatorio ? "bg-blue-500" : "bg-gray-300"
                              }`}
                    >
                      <span
                        className={`w-6 h-6 bg-white rounded-full shadow-md 
                              transition-transform duration-300 ease-in-out
                              ${
                                senhaRelatorio
                                  ? "translate-x-6"
                                  : "translate-x-0"
                              }`}
                      ></span>
                    </button>
                    <span className="text-sm">Senha nos Relatórios</span>
                  </div>

                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <button
                      type="button"
                      onClick={() => setcpfSolicitacao(!cpfSolicitacao)}
                      className={`cursor-pointer w-14 h-8 flex items-center p-1 rounded-full 
                              transition-colors duration-300 ease-in-out border-none
                              ${
                                cpfSolicitacao ? "bg-blue-500" : "bg-gray-300"
                              }`}
                    >
                      <span
                        className={`w-6 h-6 bg-white rounded-full shadow-md 
                              transition-transform duration-300 ease-in-out
                              ${
                                cpfSolicitacao
                                  ? "translate-x-6"
                                  : "translate-x-0"
                              }`}
                      ></span>
                    </button>
                    <span className="text-sm">Solicitar CPF Novo Cartão</span>
                  </div>

                  <div className="flex flex-col gap-2 text-base font-[500] w-full">
                    <button
                      type="button"
                      onClick={() => setcpfVerificacao(!cpfVerificacao)}
                      className={`cursor-pointer w-14 h-8 flex items-center p-1 rounded-full 
                              transition-colors duration-300 ease-in-out border-none
                              ${
                                cpfVerificacao ? "bg-blue-500" : "bg-gray-300"
                              }`}
                    >
                      <span
                        className={`w-6 h-6 bg-white rounded-full shadow-md 
                              transition-transform duration-300 ease-in-out
                              ${
                                cpfVerificacao
                                  ? "translate-x-6"
                                  : "translate-x-0"
                              }`}
                      ></span>
                    </button>
                    <span className="text-sm">Verificar CPF Novo Cartão</span>
                  </div>
                </div>

                <div className="flex gap-2 justify-end w-full">
                  <button
                    type="button"
                    onClick={() => {
                      closeModal();
                    }}
                    className="flex gap-2 font-[500] items-center rounded-lg text-lg border-none p-2 bg-[#e74c3c]  text-white transition cursor-pointer hover:bg-[#c0392b] font-Roboto"
                  >
                    Cancelar
                  </button>
                  <button
                    type="submit"
                    className="flex gap-2 font-[500] items-center rounded-lg text-lg border-none p-2 bg-[#2185D0] text-white transition cursor-pointer hover:bg-[#1A6DA8] font-Roboto"
                  >
                    Salvar
                  </button>
                </div>
              </form>

              <div className="flex justify-center items-center flex-col gap-2">
                <div className="flex flex-col justify-center items-center gap-2 w-full">
                  <h2 className="font-Oswald">Itens do Cardápio</h2>
                  <hr className="w-[100%] h-[2px] border-none bg-[#ccc] m-auto text-[#ccc]" />
                </div>

                <form
                  onSubmit={(e) => handleAddItem(e)}
                  className="flex flex-wrap gap-2 justify-center items-center lg:items-end"
                >
                  <div className="font-Roboto flex flex-col gap-2">
                    <label
                      className="font-Roboto text-base font-[500] w-fit"
                      htmlFor="produto"
                    >
                      Produto
                    </label>
                    <div className="font-Roboto font-[500] relative">
                      <input
                        autoComplete="off"
                        style={{
                          backgroundColor: produto?.COR
                            ? convertAPIColor(produto.COR)
                            : "",
                        }}
                        type="text"
                        name="produto"
                        className="font-Roboto w-[250px] text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="Selecione uma opção"
                        value={buscaProduto}
                        onChange={(e) => {
                          setBuscaProduto(e.target.value);
                          setAbertoProduto(!abertoProduto);
                        }}
                        onFocus={() => setAbertoProduto(!abertoProduto)}
                        required
                      />

                      {abertoProduto && (
                        <ul className="font-Roboto flex flex-col text-base font-[500] absolute z-10 w-full overflow-x-hidden bg-white border border-gray-300 rounded-md max-h-60 overflow-y-auto shadow-md">
                          {produtosFiltrados.length > 0 ? (
                            produtosFiltrados.map((option) => (
                              <li
                                key={option.CODIGO}
                                style={{
                                  backgroundColor: convertAPIColor(option.COR),
                                }}
                                className="px-4 py-2 cursor-pointer hover:bg-blue-100"
                                onClick={() => {
                                  setProduto(option);
                                  setBuscaProduto(option.DESCRICAO);
                                  setAbertoProduto(false);

                                  const grupoData = grupos.find(
                                    (grupo) => option.CODGRUPO === grupo.CODIGO
                                  );
                                  console.log("grupo", grupoData);
                                  if (grupoData) {
                                    setGrupo(grupoData);
                                    setBuscaGrupo(grupoData.DESCRICAO);
                                    setAbertoGrupo(false);
                                  }
                                  setValorProduto(option.PRECOVENDA || 0);
                                }}
                              >
                                <div className="flex box-border items-center gap-4">
                                  <img
                                    src={`/icone/${option.IMAGEM}`}
                                    alt="Produto"
                                    width={"50px"}
                                  />
                                  <span className="text-wrap break-words">
                                    {option.CODIGO} - {option.DESCRICAO}
                                  </span>
                                </div>
                              </li>
                            ))
                          ) : (
                            <li className="font-Roboto px-4 py-2 text-gray-500">
                              Nenhuma opção encontrada
                            </li>
                          )}
                        </ul>
                      )}
                    </div>
                  </div>
                  <div className="font-Roboto flex flex-col gap-2">
                    <label
                      className="font-Roboto text-base font-[500] w-fit"
                      htmlFor="grupo"
                    >
                      Grupo
                    </label>
                    <div className="font-Roboto font-[500] relative">
                      <input
                        autoComplete="off"
                        style={{
                          backgroundColor: grupo?.COR
                            ? convertAPIColor(grupo.COR)
                            : "",
                        }}
                        type="text"
                        name="grupo"
                        className="font-Roboto w-[250px] text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="Selecione uma opção"
                        value={buscaGrupo}
                        onChange={(e) => {
                          setBuscaGrupo(e.target.value);
                          //setAbertoGrupo(!abertoGrupo);
                        }}
                        onFocus={() => {
                          setBuscaGrupo("");
                          setAbertoGrupo(!abertoGrupo);
                        }}
                        required
                      />

                      {abertoGrupo && (
                        <ul className="font-Roboto flex flex-col text-base font-[500] absolute z-10 w-full overflow-x-hidden bg-white border border-gray-300 rounded-md max-h-60 overflow-y-auto shadow-md">
                          {gruposFiltrados.length > 0 ? (
                            gruposFiltrados.map((option) => (
                              <li
                                key={option.CODIGO}
                                style={{
                                  backgroundColor: convertAPIColor(option.COR),
                                }}
                                className="px-4 py-2 cursor-pointer hover:bg-blue-100"
                                onClick={() => {
                                  setGrupo(option);
                                  setBuscaGrupo(option.DESCRICAO);
                                  setAbertoGrupo(false);
                                }}
                              >
                                <div className="flex box-border items-center gap-4">
                                  <img
                                    src={`/icone/${option.IMAGEM}`}
                                    alt="Grupo"
                                    width={"50px"}
                                  />
                                  <span className="text-wrap break-words">
                                    {option.CODIGO} - {option.DESCRICAO}
                                  </span>
                                </div>
                              </li>
                            ))
                          ) : (
                            <li className="font-Roboto px-4 py-2 text-gray-500">
                              Nenhuma opção encontrada
                            </li>
                          )}
                        </ul>
                      )}
                    </div>
                  </div>

                  <div className="flex flex-col gap-2 text-base font-[500] w-fit">
                    <label htmlFor="valor">Valor</label>
                    <input
                      autoComplete="off"
                      name="valor"
                      type="number"
                      min="0"
                      step="0.01"
                      onChange={(e) => setValorProduto(e.target.value)}
                      className="font-Roboto w-[250px] lg:w-[150px] text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      value={valorProduto}
                      required
                    />
                  </div>

                  <button
                    type="submit"
                    className="flex gap-2 font-[500] items-center rounded-lg text-lg border-none p-2 bg-[#2185D0] text-white transition cursor-pointer hover:bg-[#1A6DA8] font-Roboto"
                  >
                    Adicionar Item
                  </button>
                  <button
                    onClick={() => handleNewProduct()}
                    type="button"
                    className="flex gap-2 font-[500] items-center rounded-lg text-lg border-none p-2 bg-[#2185D0] text-white transition cursor-pointer hover:bg-[#1A6DA8] font-Roboto"
                  >
                    Novo Produto
                  </button>
                </form>

                {itensCardapio.map((item) => (
                  <div
                    key={item.CODIGO + item.DESCRICAO}
                    className="flex flex-col gap-2 w-full mt-4"
                  >
                    <div
                      key={item.CODIGO + item.DESCRICAO}
                      className="flex p-2 w-full"
                    >
                      <span>
                        {item.CODIGO} - {item.DESCRICAO}
                      </span>
                    </div>

                    {item.produto.map((produto) => (
                      <div
                        style={{
                          backgroundColor: convertAPIColor(produto?.COR),
                        }}
                        className="flex gap-2 p-2 justify-between items-center rounded-lg w-full"
                        key={produto.CODIGO + produto.DESCRICAO}
                      >
                        <div className="flex gap-4 items-center">
                          <img
                            src={`/icone/${produto.IMAGEM}`}
                            alt="Produto"
                            width={"50px"}
                          />
                          <div className="flex flex-col gap-2">
                            <span>
                              {produto.CODIGO} - {produto.DESCRICAO}
                            </span>
                            <span className="font-Roboto text-sm">
                              {Number(produto.VALOR).toLocaleString("pt-BR", {
                                style: "currency",
                                currency: "BRL",
                              })}
                            </span>
                          </div>
                        </div>

                        <button
                          onClick={() =>
                            handleRemoveItem(item.CODIGO, produto.CODIGO)
                          }
                          className="bg-white cursor-pointer border border-solid border-gray-400 rounded-md p-2 hover:bg-red-500 hover:text-white transition"
                        >
                          <FaTrash size={20} />
                        </button>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          ) : modalType === "view" ? (
            <div className="flex box-border p-4 flex-col gap-2 w-full">
              <DashboardCardapio codcardapio={cardapio.CODIGO} />
            </div>
          ) : (
            <div className="flex flex-col justify-center items-center box-border p-4 gap-8 w-full">
              <h1 className="font-Oswald text-center">Excluir cardápio</h1>
              <p>
                Tem certeza que deseja excluir o cardápio{" "}
                <span className="font-bold">
                  {modalData.CODIGO}
                  {" - "}
                  {modalData.DESCRICAO}
                </span>
                ?
              </p>
              <div className="flex gap-2 justify-end w-full">
                <button
                  onClick={() => {
                    closeModal();
                  }}
                  className="flex gap-2 font-[500] items-center rounded-lg text-lg border-none p-2 bg-[#2185D0] text-white transition cursor-pointer hover:bg-[#1A6DA8] font-Roboto"
                >
                  Cancelar
                </button>
                <button
                  onClick={(e) => handleSubmit(e)}
                  className="flex gap-2 font-[500] items-center rounded-lg text-lg border-none p-2 bg-[#e74c3c] text-white transition cursor-pointer hover:bg-[#c0392b] font-Roboto"
                >
                  Excluir
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
